import { queryClient } from "@/lib/queryClient";

export function invalidateTaskQueries() {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0];
      return typeof key === "string" && (key.startsWith("/api/tasks") || key === "/api/task-boards/summaries");
    },
  });
}

export function formatUserName(user: { firstName?: string | null; lastName?: string | null; username?: string | null } | null | undefined): string {
  if (!user) return "";
  const parts = [user.firstName, user.lastName].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : (user.username ?? "");
}

export function getDisplayName(firstName: string | null | undefined, lastName: string | null | undefined, username: string | null | undefined): string {
  const parts = [firstName, lastName].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : (username ?? "");
}
